import { useAtomValue } from 'jotai/react';
import { useEffect } from 'react';

import useActiveCall from '@/hooks/use-active-call';
import { useProvider } from '@/hooks/use-provider';
import { authenticatedAtom } from '@/lib/store';
import { PROVIDERS } from '@/providers';

export const useOpenCase = () => {
  const call = useActiveCall();
  const [provider] = useProvider();
  const isAuthenticated = useAtomValue(authenticatedAtom);

  useEffect(() => {
    if (!call || !isAuthenticated) return;

    if (provider.id === PROVIDERS.SALESFORCE) {
      const caseId = call.request.getHeader('X-Salesforce-Protocol');
      if (caseId) {
        provider.openCase(caseId);
      }
    }
  }, [call, provider, isAuthenticated]);
};
